import { makeAutoObservable } from 'mobx';

export default class CampusResumeCreateRefStore {
  constructor() {
    makeAutoObservable(this);
  }

  resumeBaseInfoRef;

  resumeEduExpListRef;

  resumeWorkExpListRef;

  resumeProjectExpListRef;

  resumeCampusExpListRef;

  resumeHonorListRef;

  resumeLanguageListRef;

  resumeCertificateListRef;

  resumeSkillListRef;

  resumeThesisListRef;

  resumeCompetitionListRef;

  currentScrollRef;

  resumeBaseInfoTitleRef;

  // 校验
  validate = async () => {
    let resumeBaseInfoRefs = true;
    try {
      await this.resumeBaseInfoRef?.asyncValidateFields();
    } catch (error) {
      console.error('基本信息验证失败:', error);
      resumeBaseInfoRefs = false;
    }
    const resumeEduExpListRefs = this.resumeEduExpListRef.map((ref) => ref?.validateFields());
    const resumeWorkExpListRefs = this.resumeWorkExpListRef.map((ref) => ref?.validateFields());
    const resumeProjectExpListRefs = this.resumeProjectExpListRef.map((ref) => ref?.validateFields());
    const resumeCampusExpListRefs = this.resumeCampusExpListRef.map((ref) => ref?.validateFields());
    const resumeHonorListRefs = this.resumeHonorListRef.map((ref) => ref?.validateFields());
    const resumeLanguageListRefs = this.resumeLanguageListRef.map((ref) => ref?.validateFields());
    const resumeCertificateListRefs = this.resumeCertificateListRef.map((ref) => ref?.validateFields());
    const resumeSkillListRefs = this.resumeSkillListRef.map((ref) => ref?.validateFields());
    const resumeThesisListRefs = this.resumeThesisListRef.map((ref) => ref?.validateFields());
    const resumeCompetitionListRefs = this.resumeCompetitionListRef.map((ref) => ref?.validateFields());

    return [
      resumeBaseInfoRefs,
      ...resumeEduExpListRefs,
      ...resumeWorkExpListRefs,
      ...resumeProjectExpListRefs,
      ...resumeCampusExpListRefs,
      ...resumeHonorListRefs,
      ...resumeLanguageListRefs,
      ...resumeCertificateListRefs,
      ...resumeSkillListRefs,
      ...resumeThesisListRefs,
      ...resumeCompetitionListRefs,
    ].filter((item) => item !== undefined);
  };

  // 修改refs
  changeRef = (key: string, value: any) => {
    this[key] = value;
  };

  setTitleRef = (key: string, value: any) => {
    this[key] = value;
  };

  setCurrentScrollRef = (value: any) => {
    this.currentScrollRef = value;
  };
}
